<template>
  <v-card class="listeAllChatsAgent" v-if="sessionsChatAgent">
    <v-toolbar class="accent" dark dense>
      <v-toolbar-title>{{ $t('listOfDiscussions') }}</v-toolbar-title>
    </v-toolbar>
    <!-- Chargement -->
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <div class="ContentListChats" v-bar>
      <v-list class="listeChatsAgents">
        <template v-for="(item, i) in sessionsChatAgent">
          <v-list-tile ripple :class="{ 'grey lighten-5': chatSelected == item[0] }" :key="i">
            <div class="statusVisiteur" :class="item[5]"></div>
            <v-list-tile-content>
              <v-list-tile-title
                v-html="$tc('visitors', 1, {count: ''}) + ' ' + item[0]"
                @click="update(item)"
              ></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </div>
  </v-card>
</template>

<style>
.listeAllChatsAgent {height: 100% !important;}
.listeChatsAgents {cursor: pointer;}
.ContentListChats {height: calc(100% - 48px) !important;  overflow-y: auto;}
.ContentListeAgents ul li div {margin-left: 0px !important;}

.offline {background-color: #ef4f4f;}
.online {background-color: #1cde7b;}
.statusVisiteur { 
  height: calc(100% - 8px);
  width: 2px;
  margin-top: 4px;
  margin-bottom: 4px;
  margin-right: 4px;
}
.v-list {padding: 0px 0 !important;}
</style>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
export default {
  data () {
    return {
      loading: false,
      chatSelected: null
    }
  },

  props: ['dataAgent'],

  methods: {
    update (item) {
      this.$emit('chatSessionSelected', item[0])
      this.chatSelected = item[0]
    }
  },

  computed: {
    ...mapState('_StoreWatcheeBox', ['listeChatAgent', 'listeAllVisiteurs']),

    sessionsChatAgent () {
      let arrayChatSession = _.cloneDeep(_.filter(this.listeChatAgent, [3, this.dataAgent.id]))
      _.forEach(arrayChatSession, (chatSession, key) => {
        let index = _.findIndex(this.listeAllVisiteurs, {'visiteurID': chatSession[0]})
        if (index === -1) {
          arrayChatSession[key].push('offline notInList')
        } else {
          if (this.listeAllVisiteurs[index].socketID) {
            arrayChatSession[key].push('online')
          } else {
            arrayChatSession[key].push('offline')
          }
        }
      })
      return arrayChatSession
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/watcheebox/WzListChatsAgent.vue